export const categories = [
  {
    slug: "character-background",
    name: "角色背景",
    icon: "ri-user-heart-line",
    description: "不知火舞的出身、故事背景与角色设定全解析",
    color: "accent",
  },
  {
    slug: "skill-system",
    name: "技能体系",
    icon: "ri-flashlight-line",
    description: "必杀技、超必杀技与特殊技完整图鉴",
    color: "primary",
  },
  {
    slug: "combo-guide",
    name: "连招攻略",
    icon: "ri-sword-line",
    description: "从入门到精通的连招教学与实战技巧",
    color: "secondary",
  },
  {
    slug: "cultural-impact",
    name: "文化影响",
    icon: "ri-earth-line",
    description: "不知火舞在游戏文化与流行文化中的地位",
    color: "accent",
  },
  {
    slug: "character-ranking",
    name: "角色排行",
    icon: "ri-medal-line",
    description: "SNK女角色实力排行与人气投票分析",
    color: "primary",
  },
];

export const categoriesMap: Record<string, typeof categories[number]> = {};
categories.forEach((cat) => {
  categoriesMap[cat.slug] = cat;
});